module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headeracknow01",
      "epub:type": "acknowledgments",
      "id": "acknow",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', {
    attrs: {
      "id": "headeracknow01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuhavas0007#racknow"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("This book grew out of a doctoral research project carried out at the University of East Anglia between 2013 and 2016. I wish to express my gratitude to Diane Negra and Yvonne Tasker, whose mentorship over the years has been invaluable for transitioning the project from doctoral thesis to book. Thanks are also due to colleagues at De Montfort University for forging a supportive research atmosphere, especially Simon Mills, Heather Savigny, Justin Smith, and Paul Smith.")]), _vm._v(" "), _c('p', [_vm._v("I also want to thank my wonderful editor, Marie Sweetman, for her continuous support and her patience with me, and to all at Wayne State University Press. My thanks also to series editor Barry Keith Grant and the two anonymous reviewers for their constructive criticism and helpful comments on the manuscript.")]), _vm._v(" "), _c('p', [_vm._v("For their instrumental help, inspiration, support, and academic friendship, I am grateful to Julia Leyda, Linda Mizejewski, and Maria Sulimma. Special thanks to Miriam Kent for her support and solidarity through the years and especially for designing the book’s unique cover art.")]), _vm._v(" "), _c('p', [_vm._v("I want to express my heartfelt gratitude to Vicky Ball, my friend and colleague at De Montfort University: Lacey to my Cagney (Thelma to my Louise?) without whose personal-professional support and friendship through thick and thin I could not have completed this book and who helped me get through a great deal of professional, mental, emotional, and even medical struggles in the last couple of years.")]), _vm._v(" "), _c('p', [_vm._v("Special thanks to my friends Mártonfi Anna and Gergely Gábor for always being there for me. I am especially thankful to Gábor for patiently answering my incessant flow of questions about all manner of issues from the banal to the complex and for his selfless support, guidance, mentorship, and crystal-clear advice. Anna, I am forever grateful for our productive and chatty brainstorming sessions and online hangouts, especially in times of acute emotional need and hardship. Thank you for always having my back.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Finally, I want to thank my family at home in Szeged. I would not have been able to finish (let alone start) this work without the loving support of my parents Ilona and Miklós, and my brother Péter and his family: Henni, Hanga, Kincső, and the youngest member of the gang, Villő.")]), _vm._v(" "), _c('p', [_vm._v("This book is dedicated to the memory of my late father, Havas Miklós, who passed away during the development of this project. I am forever grateful for his encouragement and his dogged confidence in me. Köszönöm, Apa.")]), _vm._v(" "), _c('hr', {
    staticClass: "sec-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("Passages from chapters 2, 3, and 4 were first published in substantially revised form in the anthology "), _c('i', [_vm._v("Hysterical! Women in American Comedy")]), _vm._v(", ed. Linda Mizejewski and Victoria Sturtevant (University of Texas Press, 2017). Sections of chapters 5 and 6 first appeared in a piece co-written with Maria Sulimma: “Through the Gaps of My Fingers: Genre, Femininity, and Cringe Aesthetics in Dramedy Television,” "), _c('i', [_vm._v("Television and New Media")]), _vm._v(" 21, no. 1 (January 2020): 75–94.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c7a0880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-havas-0008.vue
// module id = 75
// module chunks = 0